import { AutoMap } from "@automapper/classes";

export class GlobalTaskDTO {
    @AutoMap()
    position!: number;
    @AutoMap()
    description!: string;
}